
$( document ).ready(function() {
	
		$(window).on('resize.backgroundVideo', function() {
				var videoWidth = 960;
				var videoHeight = 540;
				
				var width = $(window).width();
				var height = $('#backgroundContainer').parents('.section-window-size').height();
				
				var th = width * (videoHeight / videoWidth), tw = width;
				if (th < height) {
					th = height;
					tw = height * (videoWidth / videoHeight);
				}
				$('#backgroundContainer').css({
					height: th
				});
				
				$('.majic-stack').css({
					height: th
				});
				
				$('.content-video').css({
					height: th
				});
				
				$('#backgroundVideo').css({
					//top: 0 - ((th - height) / 2),
					left: 0 - ((tw - width) / 2),
					width: tw,
					height: th
				});			
			}).triggerHandler('resize.backgroundVideo');
			
			$(this).find('#backgroundContainer, .video-text-container').hover(function() {
				$('.video-text-container').css({ 'opacity': '1' });
			}, function() {
				$('.video-text-container').css({ 'opacity': '.5' });
			});
			
			$(this).find('#backgroundContainer, .video-text-container').on('click', function() {
				console.log("Video Clicked on, start video");
				
				var video = $("#backgroundVideo").get(0);
				
				if (video.paused) {
					video.play();
				} else {
					video.pause();
				}
			
				$("#backgroundVideo").css({"opacity":"1", "z-index":"1"});
				$(".video-text-container").css({"opacity":"0", "z-index":"0"});
				return false;
			});
			$("#backgroundVideo").bind("pause ended", function() {
				$("#backgroundVideo").css({"opacity":"0", "z-index":"0" });
				$(".video-text-container").css({"opacity":".7", "z-index":"1"});
			});
			
			console.log('background video shit loaded')
	
});




// function backgroundVideo() {
				
// 			$(window).on('resize.backgroundVideo', function() {
// 				var videoWidth = 960;
// 				var videoHeight = 540;
				
// 				var width = $(window).width();
// 				var height = $('#backgroundContainer').parents('.section-window-size').height();
				
// 				var th = width * (videoHeight / videoWidth), tw = width;
// 				if (th < height) {
// 					th = height;
// 					tw = height * (videoWidth / videoHeight);
// 				}
// 				$('#backgroundContainer').css({
// 					height: th
// 				});
				
// 				$('#backgroundVideo').css({
// 					//top: 0 - ((th - height) / 2),
// 					left: 0 - ((tw - width) / 2),
// 					width: tw,
// 					height: th
// 				});			
// 			}).triggerHandler('resize.backgroundVideo');
			
// 			$(this).find('#backgroundContainer, .video-text-container').hover(function() {
// 				$('.video-text-container').css({ 'opacity': '1' });
// 			}, function() {
// 				$('.video-text-container').css({ 'opacity': '.5' });
// 			});
			
// 			$(this).find('#backgroundContainer, .video-text-container').on('click', function() {
// 				console.log("Video Clicked on, start video");
				
// 				var video = $("#backgroundVideo").get(0);
				
// 				if (video.paused) {
// 					video.play();
// 				} else {
// 					video.pause();
// 				}
			
// 				$("#backgroundVideo").css({"opacity":"1", "z-index":"1"});
// 				$(".video-text-container").css({"opacity":"0", "z-index":"0"});
// 				return false;
// 			});
// 			$("#backgroundVideo").bind("pause ended", function() {
// 				$("#backgroundVideo").css({"opacity":"0", "z-index":"0" });
// 				$(".video-text-container").css({"opacity":".7", "z-index":"1"});
// 			});
			
// 			console.log('background video shit loaded')
// }

// //call this function on page load
// $(backgroundVideo);




